import React from 'react';
import HoldedExportsList from '../../components/exports/HoldedExportsList';

const OperatorHoldedExports = () => {
  return (
    <HoldedExportsList
      title="Exportaciones Holded"
      description="Estado de batches exportados por tenant."
    />
  );
};

export default OperatorHoldedExports;
